import { render, staticRenderFns } from "./CadastroEstoqueGrupo.vue?vue&type=template&id=e3a4dbaa&"
import script from "./CadastroEstoqueGrupo.vue?vue&type=script&lang=js&"
export * from "./CadastroEstoqueGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports